import { useMemo } from 'react';
import { CategoryFormatOption, OOHCategory, OOHCategoryFormat } from './types';
import useSWR from 'swr/immutable';

export type CategoryFormatOptions = {
  label: OOHCategory;
  options: CategoryFormatOption[];
}[];

export function useOOHCategoryFormatOptions(): CategoryFormatOptions {
  const { data } = useSWR<CategoryFormatOptions>(
    {
      url: `ooh/category_format/`,
      method: 'GET',
    },
    { suspense: true },
  );
  return data!;
}

export function useOOHCategoryFormatOptionMap(): Record<OOHCategoryFormat, CategoryFormatOption> {
  const groupedOptions = useOOHCategoryFormatOptions();

  return useMemo(() => {
    const res: Record<OOHCategoryFormat, CategoryFormatOption> = {};
    groupedOptions.map(({ options }) => {
      options.map((opt) => {
        res[opt.value] = opt;
      });
    });
    return res;
  }, [groupedOptions]);
}

export function useOOHCategoryFormatOption(value: OOHCategory | null): CategoryFormatOption | null {
  const map = useOOHCategoryFormatOptionMap();
  if (value) {
    return map[value];
  }
  return null;
}
